import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { login, googleLoginUrl } from "../API/auth";
import { buttonloginstyle } from "../help/Utils";
import { buttonloginstyle2 } from "../help/Utils";
import arrow from "../assets/right-arrow.png";
import check from "../assets/check.png";
import { FaCircleCheck } from "react-icons/fa6";
import { MdCancel, MdInfo } from "react-icons/md";
// import check from "../../assets/check.png";
const AnswerReview = () => {
  return (
     <div className="relative login_main body_padding pb-[100px]">
      <div
        style={{
          backgroundColor: "#fff",
          borderRadius: "12px",
          border: "1px solid #e5e7eb",
          boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
          padding: "35px",
          maxWidth: "650px",
          margin: "0 auto",
        }}
      >
        <img
          src={check}
          alt="Check"
          style={{ display: "block", margin: "0 auto 24px", borderRadius: "9999px" }}
        />
        <h2
          style={{
            fontSize: "28px",
            color: "#1e2b5e",
            textAlign: "center",
            marginBottom: "12px",
            fontFamily: "Georgia, serif",
          }}
        >
          You may be eligible
        </h2>
        <p style={{ color: "#1B365D", textAlign: "center", marginBottom: "24px" }}>
          This is a preliminary assessment based on your answers. It is not a guarantee of USCIS approval.
        </p>

        <div
          style={{
            backgroundColor: "#F9FAFB",
            padding: "24px",
            borderRadius: "12px",
            marginBottom: "25px",
          }}
        >
          <h5 style={{ fontSize: "24px", fontWeight: "bold", marginBottom: "16px" }}>
            Your Eligibility Summary
          </h5>
          <table style={{ fontSize: "14px", width: "100%" }}>
            <tbody>
              <tr>
                <td style={{ verticalAlign: "top", paddingBottom: "10px" }}>
                  <FaCircleCheck style={{ color: "#41C700", marginRight: "8px" }} />
                </td>
                <td>At least 8 characters long</td>
              </tr>
              <tr>
                <td style={{ verticalAlign: "top", paddingBottom: "10px" }}>
                  <FaCircleCheck style={{ color: "#41C700", marginRight: "8px" }} />
                </td>
                <td>Valid Green Card holder</td>
              </tr>
              <tr>
                <td style={{ verticalAlign: "top", paddingBottom: "10px" }}>
                  <FaCircleCheck style={{ color: "#41C700", marginRight: "8px" }} />
                </td>
                <td>At least 18 years old</td>
              </tr>
              <tr>
                <td style={{ verticalAlign: "top", paddingBottom: "10px" }}>
                  <FaCircleCheck style={{ color: "#41C700", marginRight: "8px" }} />
                </td>
                <td>No serious criminal history</td>
              </tr>
              <tr>
                <td style={{ verticalAlign: "top", paddingBottom: "10px" }}>
                  <FaCircleCheck style={{ color: "#41C700", marginRight: "8px" }} />
                </td>
                <td>Taxes are up to date</td>
              </tr>
              <tr>
                <td style={{ verticalAlign: "top", paddingBottom: "10px" }}>
                  <MdCancel style={{ color: "#FF272A", marginRight: "8px" }} />
                </td>
                <td>No false citizenship claims</td>
              </tr>
            </tbody>
          </table>
        </div>

        <h5 style={{ fontSize: "24px", fontWeight: "bold", marginBottom: "16px" }}>
          Recommended Next Steps
        </h5>

        <table style={{ width: "100%", marginBottom: "20px", fontSize: "14px" }}>
          <tbody>
            <tr>
              <td style={{ width: "40px", verticalAlign: "top" }}>
                <div
                  style={{
                    width: "32px",
                    height: "32px",
                    backgroundColor: "#F3F4F6",
                    borderRadius: "50%",
                    textAlign: "center",
                    lineHeight: "32px",
                    fontWeight: "bold",
                  }}
                >
                  1
                </div>
              </td>
              <td>
                <h6 style={{ fontWeight: "bold", fontSize: "16px", marginBottom: "4px" }}>
                  Start Your N-400 Application
                </h6>
                <p>Begin your citizenship journey with our guided application process.</p>
              </td>
            </tr>
            <tr>
              <td style={{ width: "40px", verticalAlign: "top", paddingTop: "12px" }}>
                <div
                  style={{
                    width: "32px",
                    height: "32px",
                    backgroundColor: "#F3F4F6",
                    borderRadius: "50%",
                    textAlign: "center",
                    lineHeight: "32px",
                    fontWeight: "bold",
                  }}
                >
                  2
                </div>
              </td>
              <td style={{ paddingTop: "12px" }}>
                <h6 style={{ fontWeight: "bold", fontSize: "16px", marginBottom: "4px" }}>
                  Gather Required Documents
                </h6>
                <p>We'll provide a personalized checklist of documents you need.</p>
              </td>
            </tr>
          </tbody>
        </table>

        <Link to="/subscription">
          <button
            type="button"
            style={{
              ...buttonloginstyle,
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginTop: "28px",
            }}
          >
            Start N-400 Application
            <img src={arrow} alt="arrow" style={{ marginLeft: "12px" }} />
          </button>
        </Link>

        <button
          type="button"
          style={{ ...buttonloginstyle2, width: "100%", marginTop: "20px", marginBottom: "20px" }}
        >
          Download Eligibility Report
        </button>
      </div>

      <div style={{ paddingTop: "20px", textAlign: "center" }}>
        <p style={{ fontWeight: "600" }}>
          Questions about your results?{" "}
          <a href="mailto:support@letsgetvisa.com" style={{ color: "#E76F51", fontWeight: "bold" }}>
            Contact our support team
          </a>
        </p>
      </div>
    </div>
  );
};

export default AnswerReview;